import { render, staticRenderFns } from "./SingleImage.vue?vue&type=template&id=460976de&scoped=true"
import script from "./SingleImage.vue?vue&type=script&lang=js"
export * from "./SingleImage.vue?vue&type=script&lang=js"
import style0 from "./SingleImage.vue?vue&type=style&index=0&id=460976de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460976de",
  null
  
)

export default component.exports